const Banner = {
  "--AICartoon-banner-title-color": "#FFFFFF",
  "--AICartoon-banner-subtitle-color": "#fff",

  "--AICartoon-banner-upload-bg": "rgba(0,0,0,0.4)",
  "--AICartoon-banner-upload-shadow": "",

  "--AICartoon-banner-upload-btn-color": "#212121",
  "--AICartoon-banner-upload-btn-shadow": "",
  "--AICartoon-banner-upload-btn-bg": "#77E4FF",

  "--AICartoon-banner-upload-max-color": "#999999",

  "--AICartoon-banner-upload-tips-color": "#E6E6E6",
}


const Price = {
  "--AICartoon-price-title-color": "#252325",

  "--AICartoon-price-item-shadow": "none",
  "--AICartoon-price-item-shadow-hover": "none",
  "--AICartoon-price-item-border": "3px solid #77E4FF",
  "--AICartoon-price-item-border-hover": "3px solid #77E4FF",

  // 价格顶部
  "--AICartoon-price-tag-bg": "#F2F4F3",
  "--AICartoon-price-tag-bg-hover": "#F2F4F3",
  "--AICartoon-price-tag-suffix": "#252325",
  "--AICartoon-price-tag-suffix-hover": "#252325",
  // 详情模块颜色
  "--AICartoon-price-main-bg": "#F2F4F3",
  "--AICartoon-price-main-bg-hover": "#F2F4F3",
  // 价格颜色
  "--AICartoon-price-money-suffix": "#101012",
  "--AICartoon-price-money-suffix-hover": "#101012",
  // 套餐详情颜色
  "--AICartoon-price-desc-suffix": "#252325",
  "--AICartoon-price-desc-suffix-hover": "#252325",
  // 购买按钮
  "--AICartoon-price-pay-button-suffix": "#101012",
  "--AICartoon-price-pay-button-bg": "#77E4FF",
  "--AICartoon-price-pay-button-shadow": "",
  "--AICartoon-price-pay-button-border": "2px solid #000000",

  "--AICartoon-price-pay-button-suffix-hover": "#101012",
  "--AICartoon-price-pay-button-bg-hover": "#77E4FF",
  "--AICartoon-price-pay-button-shadow-hover": "",
  "--AICartoon-price-pay-button-border-hover": "2px solid #000000",

  // 套餐 tips
  "--AICartoon-price-tip-suffix": "#252325",
  "--AICartoon-price-tip-suffix-hover": "#252325",
  "--AICartoon-price-tip-bg": "#F2F4F3",
  "--AICartoon-price-tip-bg-hover": "#F2F4F3",
}

const Questions = {
  "--AICartoon-questions-title-color": "#252325",

  "--AICartoon-questions-item-bg": "#F2F4F3",
  "--AICartoon-questions-item-bg-open": "#77E4FF",

  "--AICartoon-questions-item-boxshadow": "",
  "--AICartoon-questions-item-boxshadow-open": "",

  "--AICartoon-questions-item-border": "3px solid #77E4FF",
  "--AICartoon-questions-item-border-open": "2px solid #000000",

  "--AICartoon-questions-item-number-suffix": "#77E4FF",
  "--AICartoon-questions-item-number-suffix-open": "#000000",

  "--AICartoon-questions-item-suffix": "#101012",
  "--AICartoon-questions-item-suffix-open": "#101012",
  "--AICartoon-questions-item-des-suffix": '#101012',
}

const Comment = {
  "--AICartoon-comment-title-color": "#252325",

  "--AICartoon-comment-bg": "#fff",

  "--AICartoon-comment-item-bg": "#F2F4F3",
  "--AICartoon-comment-item-bg-hover": "#77E4FF",

  "--AICartoon-comment-item-border": "none",
  "--AICartoon-comment-item-border-hover": "none",

  "--AICartoon-comment-item-boxshadow": "none",
  "--AICartoon-comment-item-boxshadow-hover": "none",

  "--AICartoon-comment-item-subtitle-suffix": "#252325",
  "--AICartoon-comment-item-subtitle-suffix-hover": "#252325",

  "--AICartoon-comment-item-name-suffix": "#4C484C",
  "--AICartoon-comment-item-name-suffix-hover": "#4C484C",

  "--AICartoon-comment-item-city-suffix": "#4C484C",
  "--AICartoon-comment-item-city-suffix-hover": "#4C484C",
}


const Case = {
  "--AICartoon-case-title-color": "#252325",

  "--AICartoon-case-bg": "#fff",
  "--AICartoon-case-item-bg": "#F2F4F3",
  "--AICartoon-case-item-bg-hover": "#77E4FF",

  "--AICartoon-case-item-title-color": "#252325",
  "--AICartoon-case-item-title-color-hover": "#252325",
  "--AICartoon-case-item-desc-color": "#4C484C",
  "--AICartoon-case-item-desc-color-hover": "#4C484C",

  "--AICartoon-case-item-shadow": "",
  "--AICartoon-case-item-shadow-hover": "",
  "--AICartoon-case-item-border": "3px solid #77E4FF",
  "--AICartoon-case-item-border-hover": "3px solid #000000",
}

const Step = {
  "--AICartoon-step-title-color": "#fff",

  "--AICartoon-step-item-title-color": "#77E4FF",
  "--AICartoon-step-item-title-color-hover": "#121212",
  "--AICartoon-step-item-subtitle-color": "#FFFFFF",
  "--AICartoon-step-item-subtitle-color-hover": "#121212",

  "--AICartoon-step-bg": '#252525',
  "--AICartoon-step-item-bg": "#121212",
  "--AICartoon-step-item-bg-hover": "#77E4FF",
  "--AICartoon-step-item-shadow": "",
  "--AICartoon-step-item-shadow-hover": "",
  "--AICartoon-step-item-border": "none",
  "--AICartoon-step-item-border-hover": "none",
}


export const coustomAICartoonDigiCartoonizerTheme = {
  //主题背景颜色
  "--theme-primary": "#77E4FF",
  //默认黑
  "--theme-primary-black": "#252325",
  //默认白
  "--theme-primary-white": "#ffffff",
  // 页脚 logo 字体颜色
  "--theme-primary-footer-logo-suffix": "#77E4FF",
  // 页头 登录 字体颜色
  "--theme-primary-login-btn-suffix": "#fff",
  // 不透明度70%
  "--theme-primary-white-70": "#b2b2b2",
  //主题亮色
  "--theme-primary-suffix": "#212121",
  //主题深副色
  "--theme-primary-dark-sub": "#E4430F",
  //主题浅副色
  "--theme-primary-light-sub": "#FF8761",
  //价格 tag
  "--theme-primary-price-tag": "#4C3626",
  "--theme-primary-price-tag-bg": "#FFCF52",
  //tiny 类
  "--theme-primary-tiny": "#666166",
  //footer 背景色
  "--theme-primary-footer-bg": "#000000",
  //输入框聚焦
  "--theme-focus": "#3377ff",
  //输入框错误
  "--theme-focus-err": "#ea3042",

  ...Banner,
  ...Price,
  ...Questions,
  ...Comment,
  ...Case,
  ...Step
}